import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';

let registered = false;

/**
 * Registers AG Grid Enterprise once, applying the licence key from the front end configuration.
 * The key is deployed as `WebClientConfig:AgGridLicenseKey`, it is never checked into source.
 * Without a key AG Grid still runs, but it logs a licence warning and shows a watermark.
 */
export function useAgGridEnterprise(): void {
    if (registered)
        return;

    registered = true;

    const licenseKey = window.config?.agGridLicenseKey;
    if (licenseKey)
        LicenseManager.setLicenseKey(licenseKey);

    ModuleRegistry.registerModules([AllEnterpriseModule]);
}
